import { createAction, handleActions } from 'redux-actions'
import * as globalMessageActions from '../global-message'
import Y from '../../y18n'
import api from '../api'

const GET_SUBSCRIPTIONS = createAction('subscriptions/GET_SUBSCRIPTIONS')
const GET_SUBSCRIPTIONS_SUCCESS = createAction('subscriptions/GET_SUBSCRIPTIONS_SUCCESS')

const GET_SUBSCRIPTION_GRAPH_DATA = createAction('subscriptions/GET_SUBSCRIPTION_GRAPH_DATA')
const GET_SUBSCRIPTION_GRAPH_DATA_SUCCESS = createAction('subscriptions/GET_GRAPH_DATA_SUCCESS')

const CREATE_SUBSCRIPTION = createAction('subscriptions/CREATE_SUBSCRIPTION')
const CREATE_SUBSCRIPTION_SUCCESS = createAction('subscriptions/CREATE_SUBSCRIPTION_SUCCESS')

const EDIT_SUBSCRIPTION = createAction('subscriptions/EDIT_SUBSCRIPTION')
const EDIT_SUBSCRIPTION_SUCCESS = createAction('subscriptions/EDIT_SUBSCRIPTION_SUCCESS')

const DELETE_SUBSCRIPTION = createAction('subscriptions/DELETE_SUBSCRIPTION')
const DELETE_SUBSCRIPTION_SUCCESS = createAction('subscriptions/DELETE_SUBSCRIPTION_SUCCESS')

const SET_ERROR = createAction('subscriptions/SET_ERROR')

const SET_ACTIVE = createAction('subscriptions/SET_ACTIVE')
const RESET_ACTIVE = createAction('subscriptions/RESET_ACTIVE')
const UPDATE_ACTIVE = createAction('subscriptions/UPDATE_ACTIVE')

const SET_NEW = createAction('subscriptions/SET_NEW')
const RESET_NEW = createAction('subscriptions/RESET_NEW')

const SET_DELETE = createAction('subscriptions/SET_DELETE')
const RESET_DELETE = createAction('subscriptions/RESET_DELETE')

const initialState = {
  items: [],
  active: null,
  new: false,
  delete: false,
  loading: false,
  dialogLoading: false,
  error: null
}

export default handleActions(
  {
    [GET_SUBSCRIPTIONS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_SUBSCRIPTIONS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      items: action.payload
    }),
    [GET_SUBSCRIPTION_GRAPH_DATA]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_SUBSCRIPTION_GRAPH_DATA_SUCCESS]: (state, action) => {
      const item = state.items.find(sub => sub.id === action.payload.subscriptionId)
      item.data = action.payload.result.dataRemaining
      item.sms = action.payload.result.smsPercentage
      item.dates = action.payload.result.dates
      return { ...state, items: state.items, loading: false }
    },
    [CREATE_SUBSCRIPTION]: (state, action) => ({
      ...state,
      dialogLoading: true
    }),
    [CREATE_SUBSCRIPTION_SUCCESS]: (state, action) => ({
      ...state,
      dialogLoading: false
    }),
    [EDIT_SUBSCRIPTION]: (state, action) => ({
      ...state,
      dialogLoading: true
    }),
    [EDIT_SUBSCRIPTION_SUCCESS]: (state, action) => ({
      ...state,
      dialogLoading: false
    }),
    [DELETE_SUBSCRIPTION]: (state, action) => ({
      ...state,
      dialogLoading: true
    }),
    [DELETE_SUBSCRIPTION_SUCCESS]: (state, action) => ({
      ...state,
      dialogLoading: false
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      dialogLoading: false,
      error: action.payload
    }),
    [SET_ACTIVE]: (state, action) => ({
      ...state,
      active: { ...action.payload }
    }),
    [RESET_ACTIVE]: (state, action) => ({
      ...state,
      active: null,
      error: null
    }),
    [UPDATE_ACTIVE]: (state, action) => {
      var active = state.active
      active[action.payload.name] = action.payload.value
      return { ...state, active: active }
    },
    [SET_NEW]: (state, action) => ({
      ...state,
      active: action.payload,
      new: true
    }),
    [RESET_NEW]: (state, action) => ({
      ...state,
      active: null,
      new: false,
      error: null
    }),
    [SET_DELETE]: (state, action) => ({
      ...state,
      active: action.payload,
      delete: true
    }),
    [RESET_DELETE]: (state, action) => ({
      ...state,
      active: null,
      delete: false,
      error: null
    })
  },
  initialState
)

export const getSubscriptions = () => {
  return (dispatch, getState) => {
    const userId = getState().accounts.profile.userId
    if (userId) {
      dispatch(GET_SUBSCRIPTIONS())
      return api
        .get('subscriptions/getsubscriptions', '', '')
        .then(result => {
          dispatch(GET_SUBSCRIPTIONS_SUCCESS(result.subscriptions))
          localStorage.setItem('subscriptions', result.subscriptions.length)
        })
        .catch(error => {
          dispatch(SET_ERROR(error))
          dispatch(globalMessageActions.setGlobalError(Y`${error}`))
        })
    }
  }
}

export const getGraphData = (subscriptionId, count) => {
  return dispatch => {
    dispatch(GET_SUBSCRIPTION_GRAPH_DATA())
    return api
      .get('subscriptiondata', subscriptionId, `count=${count}`)
      .then(result => {
        dispatch(GET_SUBSCRIPTION_GRAPH_DATA_SUCCESS({ result, subscriptionId }))
      })
      .catch(error => {
        dispatch(SET_ERROR(error))
        dispatch(globalMessageActions.setGlobalError(Y`${error}`))
      })
  }
}

export const createSubscription = subscription => {
  return dispatch => {
    dispatch(CREATE_SUBSCRIPTION())
    return api
      .post('subscriptions/createsubscription', '', subscription)
      .then(result => {
        dispatch(resetNew())
        dispatch(CREATE_SUBSCRIPTION_SUCCESS(result))
        dispatch(getSubscriptions())
        dispatch(globalMessageActions.setGlobalSuccess(Y`Subscription was created`))
      })
      .catch(error => {
        dispatch(SET_ERROR(error))
      })
  }
}

export const editSubscription = (id, name) => {
  return dispatch => {
    dispatch(EDIT_SUBSCRIPTION())
    return api
      .post('subscriptions/updatesubscription', id, { id: id, name: name })
      .then(result => {
        dispatch(setActive())
        dispatch(EDIT_SUBSCRIPTION_SUCCESS(result))
        dispatch(getSubscriptions())
        dispatch(globalMessageActions.setGlobalSuccess(Y`Subscription was updated`))
      })
      .catch(error => {
        dispatch(SET_ERROR(error))
      })
  }
}

export const deleteSubscription = id => {
  return dispatch => {
    dispatch(DELETE_SUBSCRIPTION())
    return api
      .post('subscriptions/deletesubscription', id, '')
      .then(result => {
        dispatch(resetDelete())
        dispatch(DELETE_SUBSCRIPTION_SUCCESS(result))
        dispatch(getSubscriptions())
      })
      .catch(error => {
        dispatch(SET_ERROR(error))
      })
  }
}

export const setActive = subscription => {
  return dispatch => {
    subscription !== undefined ? dispatch(SET_ACTIVE(subscription)) : dispatch(RESET_ACTIVE())
  }
}

export const updateActive = (name, value) => {
  return dispatch => {
    dispatch(UPDATE_ACTIVE({ name, value }))
  }
}

export const setNew = () => {
  return (dispatch, getState) => {
    const country = getState().locales.country
    // init a new subscription
    const subscription = {
      name: '',
      imsi: '23820870',
      verificationCode: '',
      country: country
    }
    dispatch(SET_NEW(subscription))
  }
}

export const resetNew = () => {
  return dispatch => {
    dispatch(RESET_NEW())
  }
}

export const setDelete = subscription => {
  return (dispatch, getState) => {
    dispatch(SET_DELETE(subscription))
  }
}

export const resetDelete = () => {
  return dispatch => {
    dispatch(RESET_DELETE())
  }
}



// WEBPACK FOOTER //
// ./src/store/subscriptions/index.js